import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { StyledEngineProvider } from '@mui/material';
import App from './app/App';
import * as serviceWorker from './serviceWorker';
import { APP_LOGO, APP_NAME } from 'api/Keys';

// third party style
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import './styles/theme-base.css';

// "ResizeObserver loop completed with undelivered notifications" is a
// harmless, self-recovering browser warning (not an app bug) that fires
// when a resize callback can't be delivered within one animation frame -
// e.g. rapid layout changes when switching tabs. It only shows as a
// blocking crash because CRA's dev-only error overlay treats every
// uncaught window error as fatal. Debounce the global ResizeObserver so
// the race that produces it never happens, instead of just suppressing
// the overlay.
if (typeof window !== 'undefined' && window.ResizeObserver) {
  const NativeResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class DebouncedResizeObserver extends NativeResizeObserver {
    constructor(callback) {
      let frame = 0;
      super((entries, observer) => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => callback(entries, observer));
      });
    }
  };
}

const applyBranding = () => {
  if (APP_NAME) {
    document.title = APP_NAME;
  }

  if (APP_LOGO) {
    const selectors = ["link[rel='icon']", "link[rel='shortcut icon']"];
    selectors.forEach((selector) => {
      const link = document.querySelector(selector);
      if (link) {
        link.setAttribute('href', APP_LOGO);
      }
    });
  }
};

applyBranding();

const root = createRoot(document.getElementById('root'));

root.render(
  <StyledEngineProvider injectFirst>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StyledEngineProvider>
);

// for IE-11 support un-comment cssVars() and it's import in this file
// and in MatxTheme file

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
